import { Text } from '@instructure/ui-text';
import { Tooltip } from '@instructure/ui-tooltip';
import { IconButton } from '@instructure/ui-buttons';
import { IconWarningSolid } from '@instructure/ui-icons';
import React from 'react';
import t from '@instructure/quiz-i18n/format-message';
var renderEventSummary = function renderEventSummary(eventName, multipleSessionAttempt) {
  var multipleSessionsMessage = t('Multiple sessions detected');
  return /*#__PURE__*/React.createElement(Text, {
    as: 'div',
    color: multipleSessionAttempt ? 'danger' : 'primary'
  }, multipleSessionAttempt && /*#__PURE__*/React.createElement(Tooltip, {
    renderTip: multipleSessionsMessage,
    placement: "end",
    on: ['click', 'hover', 'focus']
  }, /*#__PURE__*/React.createElement(IconButton, {
    screenReaderLabel: multipleSessionsMessage,
    color: 'danger',
    size: 'medium',
    renderIcon: IconWarningSolid,
    withBackground: false,
    withBorder: false,
    title: multipleSessionsMessage
  })), eventName);
};
export default renderEventSummary;